import React from "react";
import TopCategoryCards from "./Cards/TopCategoryCards";

interface IProps {
  isLoading?: boolean;
  data?: {
    image?: string;
    title?: string;
    [key: string]: any;
  };
}

const TopCategory: React.FC<IProps> = ({ isLoading = false, data }) => {
  return (
    <div className="view-area-width mx-auto py-3">
      <h2 className="font-size-35px font-Lexend-SemiBold text-center mb-5 theme-color-green">
        Top Categories
      </h2>
      <div className="relative grid grid-cols-3 gap-5 2xl:gap-7 md:grid-cols-4 lg:grid-cols-6">
        {isLoading && Array.from({length : 6})?.map((item, index) => (
          <TopCategoryCards key={index} data={item} skeleton />
        ))}
        {!isLoading && data?.map((item : any, index : number) => (
          <TopCategoryCards key={index} data={item} />
        ))}
      </div>
    </div>
  );
};

export default TopCategory;
